
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7QGXJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7zgzO = parcelRequire("7zgzO");


var $kE2cJ = parcelRequire("kE2cJ");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $1v8lc = parcelRequire("1v8lc");
var $01STT = parcelRequire("01STT");

const $69f0c5af040d2896$export$d1aeb22595c6e596 = ()=>{
    const { isLicensed: isLicensed, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { match: match, location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { view: view } = match?.params || {};
    // If /wiki was SSR'd, redirect to /wiki/home after the SPA is loaded
    $69f0c5af040d2896$var$useWikiRedirectSSR();
    // Redirect to space directory if the user is either anonymous or unlicensed
    if (!isLicensed || accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_DIRECTORY).name
    });
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (!window.__SSR_RENDERED__ && true) {
        // Redirect to /wiki/home if one of the following is true:
        //   1. the route param :view is unsupported
        //   2. the recentTab query param is present
        const homeBasePath = new RegExp(`^${(0, $jlIaF.CONTEXT_PATH)}/home/?$`, 'g');
        const isBaseHomePath = Boolean(location?.pathname.match(homeBasePath));
        const isHomeRoute = (0, $01STT.SUPPORTED_ROUTES).includes(view);
        const { recentTab: recentTab } = match?.query || {};
        const shouldRedirect = recentTab || !isBaseHomePath && !isHomeRoute;
        if (shouldRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: $69f0c5af040d2896$var$getRedirectionParams(match)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1v8lc.LazyHome), null);
};
const $69f0c5af040d2896$var$useWikiRedirectSSR = ()=>{
    const { replace: replace, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $cozmU.useEffect)(()=>{
        if (!window.__SSR_RENDERED__ || match?.name !== (0, $1NBp8.WIKI).name) return;
        // Ensure that top nav is loaded before transitioning to /wiki/home. This prevents nav flicker.
        // Preloading should have already been initiated before rendering this component.
        // We just "preload" this here so that we can chain to the promise.
        replace((0, $1NBp8.HOME).toUrl(undefined, {
            query: match.query
        }));
    }, [
        replace,
        match
    ]);
};
const $69f0c5af040d2896$var$getRedirectionParams = (match)=>{
    const { query: query } = match;
    const { recentTab: recentTab } = query;
    if (recentTab !== undefined) {
        delete query.recentTab;
        return {
            query: query,
            view: $69f0c5af040d2896$var$home1_3RecentTabToHome1_5Route[recentTab]
        };
    }
    return {
        query: query
    };
};
const $69f0c5af040d2896$var$home1_3RecentTabToHome1_5Route = [
    (0, $01STT.View).RECENT,
    (0, $01STT.View).RECENT,
    (0, $01STT.View).DRAFTS,
    (0, $01STT.View).STARRED
];
module.exports["GoToHome"] = $69f0c5af040d2896$export$d1aeb22595c6e596;

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $cozmU.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("1v8lc", function(module, exports) {
$parcel$export(module.exports, "View", () => (parcelRequire("01STT")).View);
$parcel$export(module.exports, "SUPPORTED_ROUTES", () => (parcelRequire("01STT")).SUPPORTED_ROUTES);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $01STT = parcelRequire("01STT");


const $39dca29df936ba2b$export$428abac61ea05032 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZAAjv",
    name: "LazyHome",
    loader: async ()=>(await (parcelRequire("239eq"))).Home
});
module.exports["LazyHome"] = $39dca29df936ba2b$export$428abac61ea05032;

});

parcelRegister("239eq", function(module, exports) {

let $17e305c765daabe3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17e305c765daabe3$var$load("fizmj"),
    $17e305c765daabe3$var$load("l8ZRj"),
    $17e305c765daabe3$var$load("26xmI"),
    $17e305c765daabe3$var$load("ev6de"),
    $17e305c765daabe3$var$load("4G7oI"),
    $17e305c765daabe3$var$load("6wr18"),
    $17e305c765daabe3$var$load("k1ZP0"),
    $17e305c765daabe3$var$load("kujst"),
    $17e305c765daabe3$var$load("jj1og"),
    $17e305c765daabe3$var$load("diMTQ"),
    $17e305c765daabe3$var$load("fwumK"),
    $17e305c765daabe3$var$load("5WMiP"),
    $17e305c765daabe3$var$load("jL43T"),
    $17e305c765daabe3$var$load("iN26T"),
    $17e305c765daabe3$var$load("VXbA1"),
    $17e305c765daabe3$var$load("7wlV6"),
    $17e305c765daabe3$var$load("1htA7"),
    $17e305c765daabe3$var$load("a8glC"),
    $17e305c765daabe3$var$load("ccAQf"),
    $17e305c765daabe3$var$load("ffEVr"),
    $17e305c765daabe3$var$load("Wowvf"),
    $17e305c765daabe3$var$load("2l8zo"),
    $17e305c765daabe3$var$load("daX4F"),
    $17e305c765daabe3$var$load("89O2I"),
    $17e305c765daabe3$var$load("d7ovg"),
    $17e305c765daabe3$var$load("953Uz"),
    $17e305c765daabe3$var$load("hhss7"),
    $17e305c765daabe3$var$load("7EorR"),
    $17e305c765daabe3$var$load("eiF7i"),
    $17e305c765daabe3$var$load("8ouZD")
]).then(()=>parcelRequire('2xONu'));

});

parcelRegister("01STT", function(module, exports) {
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["WATCHING"] = "watching";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "watching",
    "drafts",
    "tasks"
];
module.exports["View"] = $8357fd24c5d501e8$export$27a5bd065ad55220;
module.exports["SUPPORTED_ROUTES"] = $8357fd24c5d501e8$export$f183fe8f38c8cf4f;

});


//# sourceMappingURL=GoToHome.87dbfb37.js.map
